enum Direction {
  HORIZONTAL,
  VERTICAL,
}

export default Direction;
